import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/card/card-subtitle.component.js'

const tagName = 'dap-ds-card-subtitle'

/**
 * `dap-ds-card-subtitle`
 * @summary Subtitle of the card
 * @element dap-ds-card-subtitle
 * @title - Card subtitle
 * @group card
 *
 * @property {'sm' | 'md' | 'lg'} size - The size of the card subtitle. Default is `sm`.
 * @property {'top' | 'bottom' | 'both' | 'none'} spacing - The spacing of the card subtitle. This adds a margin to the card subtitle. Default is `top`.
 * @property {string} sizeMap - Responsive size map (e.g. "md:lg").
 *
 * @slot - The content of the subtitle.
 *
 * @csspart base - The subtitle container.
 *
 * @cssproperty --dds-card-subtitle-color - The color of the subtitle text. (default: var(--dds-text-neutral-subtle))
 * @cssproperty --dds-card-subtitle-font-size - The font size of the subtitle. (default: var(--dds-font-xs))
 * @cssproperty --dds-card-subtitle-font-weight - The font weight of the subtitle. (default: var(--dds-font-weight-bold))
 * @cssproperty --dds-card-subtitle-line-height - The line height of the subtitle. (default: var(--dds-font-line-height-large))
 *
 * @cssproperty --dds-card-subtitle-padding-sm - The padding for small size. (default: 0 var(--dds-spacing-400))
 * @cssproperty --dds-card-subtitle-padding-md - The padding for medium size. (default: 0 var(--dds-spacing-400))
 * @cssproperty --dds-card-subtitle-padding-lg - The padding for large size. (default: 0 var(--dds-spacing-600))
 *
 * @cssproperty --dds-card-subtitle-margin-sm - The base margin for small size. (default: var(--dds-spacing-400))
 * @cssproperty --dds-card-subtitle-margin-md - The base margin for medium size. (default: var(--dds-spacing-400))
 * @cssproperty --dds-card-subtitle-margin-lg - The base margin for large size. (default: var(--dds-spacing-600))
 *
 * @cssproperty --dds-card-subtitle-spacing-top-sm - The top spacing for small size. (default: var(--dds-spacing-400))
 * @cssproperty --dds-card-subtitle-spacing-top-md - The top spacing for medium size. (default: var(--dds-spacing-400))
 * @cssproperty --dds-card-subtitle-spacing-top-lg - The top spacing for large size. (default: var(--dds-spacing-600))
 *
 * @cssproperty --dds-card-subtitle-spacing-bottom-sm - The bottom spacing for small size. (default: var(--dds-spacing-400))
 * @cssproperty --dds-card-subtitle-spacing-bottom-md - The bottom spacing for medium size. (default: var(--dds-spacing-400))
 * @cssproperty --dds-card-subtitle-spacing-bottom-lg - The bottom spacing for large size. (default: var(--dds-spacing-600))
 *
 * @cssproperty --dds-card-subtitle-spacing-both-sm - The both (top and bottom) spacing for small size. (default: var(--dds-spacing-400))
 * @cssproperty --dds-card-subtitle-spacing-both-md - The both (top and bottom) spacing for medium size. (default: var(--dds-spacing-400))
 * @cssproperty --dds-card-subtitle-spacing-both-lg - The both (top and bottom) spacing for large size. (default: var(--dds-spacing-600))
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSCardSubtitle',
})

export default reactWrapper
